module.exports = __webpack_public_path__ + "img/vipLogo2.0580def3.png";